import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle2, Users, Calendar, Settings } from "lucide-react";
export default function KeyComponentsOfOurRoadmap() {
  const components = [{
    id: 1,
    icon: CheckCircle2,
    title: "Product Strategy",
    description: "Comprehensive planning from concept to market-ready product, ensuring alignment with your business goals and target audience."
  }, {
    id: 2,
    icon: Users,
    title: "Vendor Sourcing",
    description: "Strategic identification and evaluation of reliable vendors, suppliers, and partners to support your product launch."
  }, {
    id: 3,
    icon: Calendar,
    title: "Timeline Management",
    description: "Detailed project roadmap with milestones, deliverables, and deadlines to keep your launch on track and on schedule."
  }, {
    id: 4,
    icon: Settings,
    title: "Technical & Support Setup",
    description: "Implementation of systems, tools, and support infrastructure to ensure smooth operations from day one."
  }];
  return <section className="bg-background py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-12">
          <h2 className="text-4xl font-bold tracking-tight text-foreground mb-4">
            Key Components of Our Roadmap
          </h2>
          <p className="text-lg text-muted-foreground">
            Our comprehensive Product Launch & Roadmap package includes everything you need to transform your idea into a successful market launch.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {components.map((component, i) => {
          const Icon = component.icon;
          return <Card key={component.id} data-index={i} className="border border-border bg-background px-6 shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
                <CardHeader className="px-0">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                    <Icon className="h-6 w-6 text-primary" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-xl text-foreground">
                    {component.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-0">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {component.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}